export interface IQuery { }

export class RevenueAccountByIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Revenues.Queries.RevenueAccountByIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	RevenueId: string

	constructor (workspaceId: number, strategyId: string, revenueId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.RevenueId = revenueId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Revenues.Queries.RevenueAccountByIdQueryV1, TCh.Domain.Quest'
	}

}

export class RevenueAccountsByStrategyIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Revenues.Queries.RevenueAccountsByStrategyIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Revenues.Queries.RevenueAccountsByStrategyIdQueryV1, TCh.Domain.Quest'
	}

}

